<template>
  <div class="input-number">
    <div class="input-number__display">
      {{ value }}
    </div>
    <div class="input-number__buttons">
      <div class="input-number__buttons-item" @click="up">
        <i class="fa fa-chevron-up"></i>
      </div>
      <div class="input-number__buttons-item" @click="down">
        <i class="fa fa-chevron-down"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [Number, String],
      default: 0
    }
  },
  methods: {
    up() {
      this.value = this.value + 1;
      this.$emit("input", this.value);
    },
    down() {
      if (this.value > 0) {
        this.value = this.value - 1;
      }
      this.$emit("input", this.value);
    }
  }
};
</script>

<style lang="scss" scoped>
.input-number {
  display: flex;
  border-radius: 0.375rem;
  overflow: hidden;
  width: 100%;
  height: 40px;
  color: #51b67e;
  &__display {
    border: none;
    border: 1px solid #51b67e;
    text-align: right;
    width: 100%;
    padding: 10px;
    border-top-left-radius: 0.375rem;
    border-bottom-left-radius: 0.375rem;
  }
  &__buttons {
    width: 40px;
    border: 1px solid #51b67e;
    border-top-right-radius: 0.375rem;
    border-bottom-right-radius: 0.375rem;
    overflow: hidden;
    &-item {
      width: 100%;
      background: white;
      border: none;
      height: 20px;
      text-align: center;
      font-size: 10px;
      line-height: 20px;
      &:hover {
        background-color: #51b67e;
        color: white;
      }
    }
  }
}
</style>
